import React from 'react';
import Hero from './Hero/Hero';
import Contact from './Contact/Contact';
import Page from '../../components/Page/Page';
import WhoWeServe from './WhoWeServe/WhoWeServe';
import ShipSmarter from './ShipSmarter/ShipSmarter';

const GlobalImports = () => {
 return (
  <Page title='CML | Global Imports'>
   <Hero />
   <WhoWeServe />
   <ShipSmarter />
   <Contact />
  </Page>
 );
};

export default GlobalImports;
